import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class TrCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (TrCalculationMethodModel._instance == null) TrCalculationMethodModel._instance = new TrCalculationMethodModel(authManager);
        return TrCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/tr-calculation-methods', 'face-pressures/tr-calculation-methods/codelist');

        this.entityName = 'face-pressures.TrCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Tr Method';
        this.setLabel = 'Tr Methods';

        this.browser = {
            name: 'default-face-pressures-trcalculationmethod-browser',
            moduleName: 'default-face-pressures-trcalculationmethod-browser',
            moduleTitle: 'Tr Methods',
            moduleStateSlotName: 'default-face-pressures-trcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-face-pressures-trcalculationmethod-editor',
            moduleName: 'default-face-pressures-trcalculationmethod-editor',
            moduleTitle: 'Tr Method',
            moduleStateSlotName: 'default-face-pressures-trcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'isDefault',
                type: 'bool',
                persistent: true,
                label: 'Is Default',
            },
        ];

    }

}
